'use strict';

var options = {
        minicart: '#mini-cart',
        minicartHideTimeout: 5000,
        minicartLeaveTimeout: 500
    },
    $cache = {},
    
    util = require('./util'),
    
    autoHide = false,
    timer = util.getTimer();

function initializeConfig(params) {
    options = $.extend({}, options, params);
}

function initializeCache() {
    $cache.minicart = $(options.minicart);
    $cache.minicartLink = $('.js-minicart-link');
}

function initializeEvents() {
    $(document)
    .on('mouseenter', options.minicart, function (event, data) {
        timer.clear();
    })
    .on('mouseleave', options.minicart, function (event, data) {
        autoHide && timer.start(options.minicartLeaveTimeout, minicartHide);
    })
    .on('product.addedToCart', function(event, response) {
        minicartShow(response);
        if (!util.isMobile()) {
            timer.clear();
            timer.start(options.minicartHideTimeout, minicartHide);
        }
    });
}

function minicartShow(html) {
    $cache.minicart.html(html);
    updateCartContent();
    $cache.minicart.addClass('js-show');
    $(document).trigger('minicart.shown', { container: $cache.minicart });
    autoHide = true;
}

/**
 * @description Sync window.pageContext.cartContent with the data-cart-content
 * attribute of the freshly rendered minicart
 */
function updateCartContent() {
    var pageContext = window.pageContext;

    if (!(pageContext && pageContext.cartContent)) {
        return;
    }

    var miniCartContent = $cache.minicart.find('.b-mini_cart-total[data-cart-content]')[0];
    var updatedCartContent = miniCartContent && miniCartContent.dataset.cartContent;

    if (!updatedCartContent) {
        return;
    }

    try {
        var parsedCartContent = JSON.parse(updatedCartContent);

        if (parsedCartContent && typeof parsedCartContent === 'object') {
            pageContext.cartContent = parsedCartContent;
        }
    } catch (error) {
        return;
    }
}

function minicartHide(delay) {
    timer.clear();
    $cache.minicart.removeClass('js-show');
    $(document).trigger('minicart.hidden', { container: $cache.minicart });
    autoHide = false;
}

module.exports = {
    init: function(params) {
        initializeConfig(params);
        initializeCache();
        initializeEvents();
    },
    update: function (showOnLoad) {
        var $request = $.ajax({
            'url' : Urls.minicart
        }).done(function (response) {
            $cache.minicart.html(response);
        });

        !!showOnLoad && $request.done(show);
    },
    minicartShow: minicartShow
};
